import React from 'react'

const Error = () => {
  return (
    <div className='container-fluid error'>
      <div className='row'>
        <div className='col-12 error_dev' >
          <img src='../images/error.png' alt='error' title='error page' />
          <strong>Opps! : 404 Error Page Found</strong>
        </div>
      </div>
    </div>
  )
}

export default Error; 